import React from 'react';
import styled from 'styled-components';
import { Currency } from '~/components';
import { useNumberFormat } from '~/hooks';
import { colors, weights } from '~/styles';

const Summary = styled.div`
  display: flex;
  align-items: center;
  background: ${colors.white};
  box-shadow: 0 3px 15px ${colors.grey10};
  border-radius: 5px;
  transition: opacity 250ms;
  opacity: ${({ fade }) => (fade ? 0.2 : 1)};
  width: 100%;
  margin-bottom: 1rem;
`;

const SummaryBox = styled.div`
  display: flex;
  flex: 1;
  padding: 1rem 1rem;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-left: 1rem;
  font-weight: ${weights.bold};
  font-size: 1rem;

  &:not(:first-child) {
    border-left: 1px solid ${colors.grey10};
  }

  p {
    font-size: 0.75rem;
    font-weight: ${weights.normal};
    line-height: 1rem;
    white-space: nowrap;
  }
`;

function OpportunityProjectsBoxes({ opportunity, availableAmount, projectCount }) {
  const numberFormat = useNumberFormat({ minimumFractionDigits: 0, maximumFractionDigits: 0 });

  return (
    <Summary>
      <SummaryBox>
        <Currency
          value={opportunity.amount}
          currency={opportunity.currency}
          minimumFractionDigits={0}
          maximumFractionDigits={0}
        />
        <p>Total Opportunity Amount</p>
      </SummaryBox>
      <SummaryBox>
        <Currency
          value={availableAmount}
          currency={opportunity.currency}
          minimumFractionDigits={0}
          maximumFractionDigits={0}
        />
        <p>Available Amount</p>
      </SummaryBox>

      <SummaryBox>
        {numberFormat.format(projectCount)}
        <p>Associated Projects</p>
      </SummaryBox>
    </Summary>
  );
}

export default OpportunityProjectsBoxes;
